interface PartnerSlugSources {
  // From the URL path. Absent on the portal's fixed auth paths, which have no
  // slug segment.
  fromPath?: string;
  // From the `partnerSlug` query parameter, which carries the partner across the
  // auth round trip because the identity provider's return address cannot hold a
  // slug in its path.
  fromQuery?: string;
  // Last written by the login or signup page. Shared across tabs and outlives the
  // session that wrote it, so it may name a partner the reader never asked for.
  fromStorage?: string | null;
}

// The path wins. It is the address a partner or support agent was actually given,
// and it is the only source that cannot be stale: the query parameter is derived
// from it, and storage may hold a partner from an unrelated earlier visit. Reading
// storage first lets a previous partner's portal render at this partner's URL.
export function resolvePartnerSlug({
  fromPath,
  fromQuery,
  fromStorage,
}: PartnerSlugSources): string | undefined {
  return fromPath || fromQuery || fromStorage || undefined;
}
